export class SimpleCoordinates {
  latitude: number;
  longitude: number;
  accuracy?: number;
}
